<mat-tab-group>
  <mat-tab label="Doc from Gmail">
    <div class="outer-trim">
      <div class="inner-trim">
        <p class="description">
          Based on the pain point of repeatedly
          copy/pasting
          text from Gmail to Google Docs in order to create a new doc,
          I
          here propose a new feature that would allow Gmail
          users to create a doc by highlighting text blocks and then
          selecting ‘Create Doc’ from the ‘More’ menu.
        </p>
      </div>
    </div>
    <div class="outer-trim">
      <div class="inner-trim">
        <div class="pdf-container">
          <span class="pdf-caption">A user flow listing the steps the user takes to complete the action</span>
          <pdf-viewer [render-text]="true"
                      [src]="stepsCreateDocDefaultsSrc"
                      [zoom]="mo.isActive('xs') || mo.isActive('sm') ? getPdfViewZoomLevel() : 1"
                      style="display: block;"
          ></pdf-viewer>
        </div>
      </div>
    </div>
    <div class="outer-trim">
      <div class="inner-trim">
        <div class="pdf-container">
          <span class="pdf-caption">A user flow diagram illustrating the steps the user takes to complete the action</span>
          <pdf-viewer [render-text]="true"
                      [src]="diagramCreateDocDefaultsSrc"
                      [zoom]="mo.isActive('xs') || mo.isActive('sm') ? getPdfViewZoomLevel() : 1"
                      style="display: block;"
          ></pdf-viewer>
        </div>
      </div>
    </div>
    <div class="outer-trim">
      <div class="inner-trim">
        <figure>
          <figcaption>A graphic mock showing a user highlights
            multiple
            text blocks using
            option-click-drag
          </figcaption>
          <img
            [src]="mockCreateDocDefaultsHighlightText"
            class="max-size"/>
        </figure>
      </div>
    </div>
    <div class="outer-trim">
      <div class="inner-trim">
        <figure>
          <figcaption>User opens 'More' menu and selects 'Create
            Doc > Default Settings' from sub-menu
          </figcaption>
          <img
            [src]="mockCreateDocDefaultsMoreMenu"
            class="max-size"/>
        </figure>
      </div>
    </div>
    <div class="outer-trim">
      <div class="inner-trim">
        <figure>
          <figcaption>System creates new Google Doc from selected
            text and
            default settings
          </figcaption>
          <img
            [src]="mockNewDocFromGmail"
            class="max-size"/>
        </figure>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Illuminating Co.">
    <div class="outer-trim">
      <div class="inner-trim">
        <p class="description">
          <a
            href="https://www.firstenergycorp.com/illuminating_company.html"
            target="_blank">The Illuminating Company’s home page</a>
          website
          might
          benefit from a redesign. I have
          re-envisioned the page in Photoshop by enhancing the branded
          design and color
          scheme, and tightening the layout such that
          primary controls and features appear within
          traditional browsers and phones.
        </p>
      </div>
    </div>
    <div class="outer-trim">
      <div class="inner-trim">
        <figure>
          <figcaption>Vibrant brand design and coloring within a
            concise
            layout
          </figcaption>
          <img
            [src]="mockIlluminatingCoWeb"
            class="max-size"/>
        </figure>
      </div>
    </div>
    <div class="outer-trim">
      <div class="inner-trim">
        <figure>
          <figcaption>Login palette opened</figcaption>
          <img
            [src]="mockIlluminatingCoWebLogin"
            class="max-size"/>
        </figure>
      </div>
    </div>
    <div class="outer-trim">
      <div class="inner-trim">
        <figure>
          <figcaption>Main nav link menu opened</figcaption>
          <img
            [src]="mockIlluminatingCoWebNav"
            class="max-size"/>
        </figure>
      </div>
    </div>
    <div class="outer-trim">
      <div class="inner-trim">
        <figure>
          <figcaption>Mobile layout maintains vibrant design
          </figcaption>
          <img
            [src]="mockIlluminatingCoPhone"/>
        </figure>
      </div>
    </div>
    <div class="outer-trim">
      <div class="inner-trim">
        <figure>
          <figcaption>Mobile layout with menu opened</figcaption>
          <img
            [src]="mockIlluminatingCoPhoneMenu"/>
        </figure>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Zephyr Logo">
    <div class="outer-trim">
      <div class="inner-trim">
        <p class="description">
          This boutique recruiting firm requested a logo that would
          reflect their friendly character and
          high-touch practice. In the series below, I show the
          design steps I took to create the
          logo, from initial conception to completed logo, as it
          appears on Zephyr’s web site and other promo materials.
        </p>
      </div>
    </div>
    <div class="outer-trim">
      <div class="inner-trim">
        <figure>
          <figcaption>Official Zephyr Recruiting Logo</figcaption>
          <img
            [src]="imgZephyrLogoOfficial"
            class="max-size"/>
        </figure>
      </div>
    </div>
    <div class="outer-trim">
      <div class="inner-trim">
        <figure>
          <figcaption>Initial sketch on graph paper</figcaption>
          <img
            [src]="imgZephyrLogoInitial"
            class="max-size"/>
        </figure>
      </div>
    </div>
    <div class="outer-trim">
      <div class="inner-trim">
        <figure>
          <figcaption>Initial sketch of wisp concept for the 'e'
          </figcaption>
          <img
            [src]="imgZephyrLogoWisps"
            class="max-size"/>
        </figure>
      </div>
    </div>
    <div class="outer-trim">
      <div class="inner-trim">
        <figure>
          <figcaption>Selection of Kushan Script font</figcaption>
          <img
            [src]="imgZephyrLogoText"
            class="max-size"/>
        </figure>
      </div>
    </div>
    <div class="outer-trim">
      <div class="inner-trim">
        <figure>
          <figcaption>Design of the signature Zephyr 'Wisps', by
            pivoting the stem of the letter 'i' in the Kushan
            Script font (as seen above)
          </figcaption>
          <img
            [src]="imgZephyrWisps"
            class="max-size"/>
        </figure>
      </div>
    </div>
    <div class="outer-trim">
      <div class="inner-trim">
        <figure>
          <figcaption>The logo on the
            <a href="https://www.zephyrrecruiting.com/"
               target="_blank">Zephyr Recruiting
              web site.</a></figcaption>
          <img
            [src]="imgZephyrScreenshot"
            class="max-size"/>
        </figure>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
